import { Flex, ListItem, UnorderedList } from '@chakra-ui/react';
import { Alert, AlertIcon, AlertTitle } from '@chakra-ui/react';
import * as React from 'react';

import { FieldValidationError } from '../../../../client/legacy-shared-modules/csv/csv-field-mapping';

type IValidationErrorsProps = {
  validationErrors: FieldValidationError;
};

export const ValidationErrors: React.FC<IValidationErrorsProps> = ({
  validationErrors,
}) => {
  const errors = validationErrors.errors;
  return (
    <Alert status="error">
      <AlertIcon />

      <Flex direction="column" ml="2">
        <AlertTitle>{`There ${
          errors.length > 1 ? `are ${errors.length} errors` : `is 1 error`
        }`}</AlertTitle>

        <UnorderedList>
          {errors.map((error) => (
            <ListItem key={error}>{error}</ListItem>
          ))}
        </UnorderedList>
      </Flex>
    </Alert>
  );
};
